<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Vincular Compradores"
    @click:primary="salvarVinculacao()"
  >
    <template #ativador>
      <v-badge bordered color="white" overlap>
        <template #badge>
          <span style="color: #000000">{{ selects.departamentos.length }}</span>
        </template>

        <v-btn
          color="primary"
          small
          @click="dialog_ativo = true"
        >
          Vincular Compradores
        </v-btn>
      </v-badge>
    </template>

    <SysSegmentoAutocomplete
      v-model="selects.departamentos"
      label="Selecione os departamentos"
      multiple
      outlined
      :hide-details="false"
      :qtde-visivel-selecionados="1"
      :error-messages="departamentosErrors"
      @input="$v.selects.departamentos.$touch()"
      @blur="$v.selects.departamentos.$touch()"
    />

    <SysCompradorAutocomplete
      v-model="selects.comprador"
      label="Selecione o comprador"
      outlined
      desabilitarJoin
      class="mb-n3"
      :error-messages="compradorErrors"
      @input="$v.selects.comprador.$touch()"
      @blur="$v.selects.comprador.$touch()"
    />
  </SysDialog>
</template>

<script>

import SysCompradorAutocomplete from '../../utils/crud/SysCompradorAutocomplete'
import SysSegmentoAutocomplete from '../../utils/crud/SysSegmentoAutocomplete'
import SysDialog from '../../padraoDeLayout/SysDialog.vue'
import { arrayColumn } from '@/helpers/index.js'
import { required } from "vuelidate/lib/validators"
import { vincularDepartamentosAoComprador } from "@/api/Secoes"



export default {
  components: {
    SysCompradorAutocomplete,
    SysSegmentoAutocomplete,
    SysDialog
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: Boolean,
    departamentos_datadable_selecionada: Array
  },
  data: () => ({
    selects: {
      departamentos: [],
      comprador: "",
    },
  }),
  computed: {
    dialog_ativo: {
      get(){
        return this.modelValue;
      },
      set(valor){
        this.$emit('update:modelValue', valor)
      }
    },
    departamentosErrors() {
      const errors = [];
      if (!this.$v.selects.departamentos.$dirty) return errors;
      !this.$v.selects.departamentos.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },

    compradorErrors() {
      const errors = [];
      if (!this.$v.selects.comprador.$dirty) return errors;
      !this.$v.selects.comprador.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    }
  },
  validations: {
    selects: {
      departamentos: {
        required,
      },
      comprador: {
        required,
      }
    }
  },
  watch: {
    departamentos_datadable_selecionada() {
      if(this.departamentos_datadable_selecionada.length > 0) {
        this.selects.departamentos = arrayColumn(this.departamentos_datadable_selecionada, 'iddepartamento').map(item => String(item));
      } else {
        this.selects.departamentos = []
      }
    },
    dialog_ativo() {
      if(this.dialog_ativo) {
        const item = this.departamentos_datadable_selecionada.find(item => item.idcomprador > 0);
        this.selects.comprador = item ? item.idcomprador : '';
      }

      if(!this.dialog_ativo)  {
        this.$v.$reset();
        this.selects.departamentos = [];
        this.selects.comprador = "";
      }
    }
  },
  methods: {
    salvarVinculacao() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        departamentos: this.selects.departamentos,
        idcomprador: this.selects.comprador
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        vincularDepartamentosAoComprador(parametros)
        .then((response) => {
          this.dialog_ativo = false;
          this.$emit('update:departamentos')
        })
        .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  },

}

</script>

<style>

</style>
